
    import { defineComponent } from 'vue'
    import Dialog from 'primevue/dialog'
    import Listbox from 'primevue/listbox'
    import { mapState } from 'vuex'
    import store from '@/App.store'

    import { AxiosResponse } from 'axios'

    interface Language {
        locale: string
        disabled: boolean | false
    }

    export default defineComponent({
        name: 'language-dialog',
        components: {
            Dialog,
            Listbox
        },
        data() {
            return {
                languages: Array<Language>()
            }
        },

        props: {
            visibility: Boolean
        },
        emits: ['update:visibility', 'update:loading'],
        methods: {
            changeLanguage(language) {
                let splittedLanguage = language.locale.split('_')

                let url = '/knowage/servlet/AdapterHTTP?'
                url += 'ACTION_NAME=CHANGE_LANGUAGE'
                url += '&LANGUAGE_ID=' + splittedLanguage[0]
                url += '&COUNTRY_ID=' + splittedLanguage[1].toUpperCase()
                url += '&SCRIPT_ID=' + (splittedLanguage.length > 2 ? splittedLanguage[2].replaceAll('#', '') : '')
                url += '&THEME_NAME=sbi_default'

                this.$emit('update:loading', true)
                this.$http.get(url).then(
                    () => {
                        store.commit('setLocale', language.locale)
                        localStorage.setItem('locale', language.locale)
                        this.$i18n.locale = language.locale

                        this.closeDialog()
                        this.$router.go(0)
                        this.$forceUpdate()
                    },
                    (error) => console.error(error)
                )
                this.$emit('update:loading', false)
            },
            closeDialog() {
                this.$emit('update:visibility', false)
            }
        },
        computed: {
            ...mapState({
                locale: 'locale'
            })
        },
        watch: {
            visibility(newVisibility) {
                if (newVisibility && this.languages.length == 0) {
                    this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/languages').then(
                        (response: AxiosResponse<any>) => {
                            let languagesArray = response.data.sort()

                            for (var idx in languagesArray) {
                                var disabled = false
                                if (languagesArray[idx] === this.$i18n.locale) {
                                    disabled = true
                                }
                                this.languages.push({ locale: languagesArray[idx], disabled: disabled })
                            }
                        },
                        (error) => console.error(error)
                    )
                }
            }
        }
    })
